import moment from 'moment';
import type { BillingSubscriptionState } from '@/services/models';

export const formatBillingDate = (date: number) =>
  `${moment.unix(date).format('DD MMMM YYYY')} UTC`;

export const getNextBillingAt = (billing: BillingSubscriptionState) =>
  moment.unix(Number(billing.subscriptionStart || 0)).add(1, 'month').unix();

export const getNextBillingEnd = (billing: BillingSubscriptionState) =>
  moment.unix(Number(billing.subscriptionEnd || 0)).add(1, 'month').unix();

export const isFreePlan = (billing: BillingSubscriptionState) =>
  billing.planId === 'free' || billing.planId === 'basic';
